import { alert, format_date, toFixed, total, GET } from "./CustomComponent.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ThaiBahtText from "thai-baht-text";
import {
  replaceText,
  project,
} from "./CustomComponent.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
}; 

function value(text = " ", width = 300, alignment = "center") {
  return {
    width: width,
    stack: [
      {
        text: text || " ",
        fontSize: 16,
        alignment: alignment,
        margin: [12, 0, 12, 0],
      },
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: width,
            y2: 0,
            lineWidth: 1,
            dash: { length: 2 },
          },
        ],
        margin: [0, -6, 0, 0]
      },
    ],
  };
}
function checkbox(checked, size = 12) {
  return checked
    ? {
        canvas: [
          // กล่องดำ
          {
            type: "rect",
            x: 0,
            y: 0,
            w: size,
            h: size,
            color: "black",
          },
          // เช็คถูก
          {
            type: "polyline",
            lineWidth: 2,
            lineColor: "white",
            points: [
              { x: size * 0.2, y: size * 0.55 },
              { x: size * 0.45, y: size * 0.75 },
              { x: size * 0.8, y: size * 0.25 },
            ],
          },
        ],
        width: size + 10,
        height: size,
        margin: [3, 4, 2, 4],
      }
    : {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: size,
            h: size,
            lineWidth: 1,
          },
        ],
        width: size + 10,
        height: size,
        margin: [3, 4, 2, 4],
      };
}

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}
async function open(docDefinition) {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download("ทดสอบ");
    if (error === "Open PDF in new window blocked by browser") {
      alert(
        "warning",
        "แจ้งเตือน",
        "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์"
      );
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// รายงานกระแสเงินสดรับ - จ่าย
async function report_cash_flow_report_table(data,title_data) {
  const { prev_balance_bank, prev_balance_cash, income_received, other_income, deduction_amount, expense_amount, bank_deposit_balance, cash_deposit_balance, outstanding_debt, year, month } = data;
  const selected = title_data.prev_balance_bank.selected &&
    title_data.prev_balance_cash.selected &&
    title_data.income_received.selected &&
    title_data.other_income.selected &&
    title_data.deduction_amount.selected &&
    title_data.expense_amount.selected &&
    title_data.bank_deposit_balance.selected &&
    title_data.cash_deposit_balance.selected &&
    title_data.outstanding_debt.selected;
  const listSubItems = (item) =>
    item?.title?.find((t) => t?.type === "list")?.list || [];
  const body = JSON.stringify([
    { text: `${project["project_name"]}`, fontSize: 28, alignment: "center", bold: true  },
    { text: `รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย`, fontSize: 28, alignment: "center", bold: true  },
    { text: `สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`, fontSize: 28, alignment: "center", bold: true  },
    { text: ` `, fontSize: 4 },
    // SECTION 1
    title_data.prev_balance_bank.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...prev_balance_bank.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(prev_balance_bank.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 2
    title_data.prev_balance_cash.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รายการเงินสดคงเหลือในมือและอื่นๆ", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...prev_balance_cash.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(prev_balance_cash.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือ และอื่นๆ ยกไป", colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed(total(prev_balance_bank.data,"amount") + total(prev_balance_cash.data,"amount"))}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 3
    title_data.income_received.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รายการรับเงิน", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...income_received.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(income_received.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},

    { text: ` `, fontSize: 4 },
    // SECTION 4
    title_data.other_income.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รายรับอื่นๆ", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...other_income.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(other_income.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},

    { text: ` `, fontSize: 4 },
    // SECTION 5
    title_data.deduction_amount.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "หัก", fillColor: "#dc3545", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...deduction_amount.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(deduction_amount.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: `รวมรับเงินและนำฝากประจำเดือน ${format_date( new Date(year, month - 1), "mmmm yyyy", "th" )}`, colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed( total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") )}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 6
    title_data.expense_amount.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รายการจ่ายเงิน", fillColor: "#dc3545", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...expense_amount.data.filter(e=> e.is_active !== false).flatMap((item, index) => [
            [
              { text: `${index + 1}`, alignment: "center" },
              { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
              { text: `${toFixed(item.amount)}`, alignment: "right" },
            ],
            ...listSubItems(item).map((sub, subIdx) => [
              { text: `${index + 1}.${subIdx + 1}`, alignment: "center", italics: true, color: "#6c757d" },
              { text: `     ${sub.value}`, alignment: "left", italics: true, color: "#6c757d" },
              { text: `${toFixed(sub.amount)}`, alignment: "right", italics: true, color: "#6c757d" },
            ]),
          ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(expense_amount.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: `ประจำเดือน ${format_date( new Date(year, month - 1), "mmmm yyyy", "th" )} รายการรับเงิน ${total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") < 0 ? "น้อยกว่า" : "มากกว่า"} รายการจ่ายเงิน`, colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed( total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount"))}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: `รวมรายการรับเงิน ${total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") + total(prev_balance_bank?.data, "amount") + total(prev_balance_cash?.data, "amount") < 0 ? "น้อยกว่า" : "มากกว่า"} รายการจ่ายเงินสะสม`, colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed( total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") + total(prev_balance_bank?.data, "amount") + total(prev_balance_cash?.data, "amount") )}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 7
    title_data.bank_deposit_balance.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: `ยอดเงินฝากธนาคาร ${project?.project_name || "ผู้ดูแลระบบ"}`, fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...bank_deposit_balance.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(bank_deposit_balance.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 8
    title_data.cash_deposit_balance.selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รายการเงินสดคงเหลือในมือและอื่นๆ", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...cash_deposit_balance.data.filter(e=> e.is_active !== false).map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(cash_deposit_balance.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือและอื่นๆ ยกไป", colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed( total(bank_deposit_balance?.data, "amount") + total(cash_deposit_balance?.data, "amount"))}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // TOTAL
    // selected ? {
    //   table: {
    //     headerRows: 0,
    //     widths: [32, "*", 70],
    //     body: [
    //       [ { text: `ประจำเดือน ${format_date( new Date(year, month - 1), "mmmm yyyy", "th" )} รายการรับเงิน มากกว่า รายการจ่ายเงิน`, colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${( total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") + total(bank_deposit_balance?.data, "amount") + total(cash_deposit_balance?.data, "amount") + total(prev_balance_bank?.data, "amount") + total(prev_balance_cash?.data, "amount") )}`, alignment: "right", fillColor: "#e7f1ff"} ],
    //       ],
    //   },
    // } : {text: ""},
    // { text: ` `, fontSize: 4 },
    // TOTAL
    selected ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "ส่วนต่างยอดปิดบัญชี", colSpan: 2, fillColor: "#e7f1ff" }, "", { text: `${toFixed( (
                                      total(income_received?.data, "amount") +
                                        total(other_income?.data, "amount") +
                                        total(deduction_amount?.data, "amount") +
                                        total(expense_amount?.data, "amount") +
                                        total(prev_balance_bank?.data, "amount") +
                                        total(prev_balance_cash?.data, "amount")
                                    )-
          (
                                      total(bank_deposit_balance?.data, "amount") +
                                        total(cash_deposit_balance?.data, "amount")
                                    ))}`, alignment: "right", fillColor: "#e7f1ff"} ],
          ],
      },
    } : {text: ""},
    { text: ` `, fontSize: 4 },
    // SECTION 8
    title_data.outstanding_debt?.selected && outstanding_debt ? {
      table: {
        headerRows: 0,
        widths: [32, "*", 70],
        body: [
          [ { text: "หนี้คงค้าง ณ สิ้นสุด ประจำเดือน ", fillColor: "#198754", color: "#ffffff", colSpan: 3 }, "", "" ],
          ...outstanding_debt?.data?.map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.title.map(e=>e.value).join(" ")}`, alignment: "left" },
            { text: `${toFixed(item.amount)}`, alignment: "right" },
            ]),
          [ { text: "รวมทั้งสิ้น", colSpan: 2 }, "", { text: `${toFixed(total(outstanding_debt.data,"amount"))}`, alignment: "right" } ],
        ],
      },
    } : {text: ""},
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, `รายงานกระแสเงินสดรับ - จ่าย${format_date( new Date(data.year, data.month - 1), "mmmm yyyy", "th" )}.pdf`);
}
async function report_cash_flow_report_full(data, title_data) {
  const {
    prev_balance_bank,
    prev_balance_cash,
    income_received,
    other_income,
    deduction_amount,
    expense_amount,
    bank_deposit_balance,
    cash_deposit_balance,
    outstanding_debt,
    year,
    month,
  } = data;

  // 🔥 helper กัน error + ลดซ้ำ
  const listSubItems = (item) =>
    item?.title?.find((t) => t?.type === "list")?.list || [];

  const buildSection = (source, title, selected) => {
    if (!selected) return [];

    return (source?.data || []).filter((e) => e.is_active !== false).map((item, index) => ({
      stack: [
        {
          text: title,
          fontSize: 20,
          bold: true,
          alignment: "left",
        },
        {
          text: `${index + 1}. ${item?.title?.map(e => e.value)?.join(" ") || ""} ${toFixed(item?.amount)} บาท`,
          alignment: "left",
        },
        ...listSubItems(item).map((sub, subIdx) => ({
          text: `     ${index + 1}.${subIdx + 1} ${sub?.value || ""} ${toFixed(sub?.amount)} บาท`,
          alignment: "left",
          italics: true,
          color: "#6c757d",
        })),
        item?.image
          ? { image: item.image, fit: [500, 500] }
          : { text: "" },
        { text: "", pageBreak: "after" },
      ],
    }));
  };

  const content = [
    {
      text: `${project["project_name"]}`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    { text: " ", fontSize: 4 },

    // ✅ ใช้ helper
    ...buildSection(prev_balance_bank, "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา", title_data?.prev_balance_bank?.selected),
    ...buildSection(prev_balance_cash, "รายการเงินสดคงเหลือในมือและอื่นๆ", title_data?.prev_balance_cash?.selected),
    ...buildSection(income_received, "รายการรับเงิน", title_data?.income_received?.selected),
    ...buildSection(other_income, "รายรับอื่นๆ", title_data?.other_income?.selected),
    ...buildSection(deduction_amount, "หัก", title_data?.deduction_amount?.selected),
    ...buildSection(expense_amount, "รายการจ่ายเงิน", title_data?.expense_amount?.selected),
    ...buildSection(bank_deposit_balance, `ยอดเงินฝากธนาคาร ${project?.project_name || ""}`, title_data?.bank_deposit_balance?.selected),
    ...buildSection(cash_deposit_balance, "รายการเงินสดคงเหลือในมือและอื่นๆ", title_data?.cash_deposit_balance?.selected),
    ...buildSection(outstanding_debt, "หนี้คงค้าง", title_data?.outstanding_debt?.selected),
  ];

  const docDefinition = {
    pageSize: "A4",
    content,
    defaultStyle: {
      font: "THSarabunNew",
      fontSize: 16,
      lineHeight: 1,
    },
    pageMargins: [40, 40, 40, 40],
  };

  print(
    docDefinition,
    `รายงานกระแสเงินสดรับ - จ่าย${format_date(
      new Date(data.year, data.month - 1),
      "mmmm yyyy",
      "th"
    )} รายละเอียด.pdf`
  );
}

// รายงานกระแสเงินสดรับ - จ่าย
async function report_petty_cash_report_table(data_petty_cash, year, month) {
  const status = {
    pending: {
      name: "รอตรวจสอบ",
      style: "text-warning",
      role: "super_user,admin,accounting",
    },
    fix: {
      name: "แก้ไข",
      style: "text-danger",
      role: "super_user,admin,accounting",
    },
    fixed: {
      name: "แก้ไขแล้ว",
      style: "text-info",
      role: "super_user,admin,accounting,finance,project_manager,center_manager",
    },
    approved: {
      name: "อนุมัติ",
      style: "text-success",
      role: "super_user,admin,accounting",
    },
  };

  // --- Helpers ---
  const getDynamicLabels = (item) =>
    [1, 2, 3, 4, 5, 6].map((i) => item[`expenses_type_label_${i}`]).filter(Boolean);

  const cal_local = (item, cash_id) => {
    if (cash_id === "") return Number(item.limit_withdraw?.amount || 0);
    let spent = 0;
    item.list_cash_spend?.forEach((cash, index) => {
      if (index <= cash_id) {
        spent += total(cash.amount, "amount");
      }
    });
    return Number(item.limit_withdraw?.amount || 0) - spent;
  };

  // --- ฟังก์ชันสร้างแถวข้อมูล (Dynamic Columns) ---
  const createDataRow = (rowData, rowIndex, labels, parentItem, isSpecial = false) => {
    // ดึงเฉพาะ labels ที่มี (ถ้าไม่มีเลยให้เว้นว่างไว้ 1 ช่องกันบั๊ก)
    const amounts = labels.length > 0 
      ? labels.map((_, i) => ({ text: toFixed(rowData?.amount?.[i]?.amount || 0), alignment: "right" }))
      : [{ text: "", alignment: "center" }]; 

    return [
      { text: rowIndex === "" ? "" : rowIndex + 1, alignment: "center" },
      { text: rowData.date ? format_date(rowData.date) : "", alignment: "center" },
      { text: rowData.name || "", alignment: "left" },
      { text: rowData.volumn_no || "", alignment: "center" },
      { text: rowData.no || "", alignment: "center" },
      ...amounts, // ประเภทตาม label ที่มี
      { text: toFixed(total(rowData.amount, "amount")), alignment: "right", bold: isSpecial },
      { text: toFixed(typeof rowData.amount === "object" ? cal_local(parentItem, rowIndex) : rowData.amount), alignment: "right", bold: isSpecial },
      { text: status[rowData.status]?.name || "", alignment: "center" },
      { text: rowData.receipt ? "มี" : "ไม่มี", alignment: "center" },
      { text: rowData.copy_id_card ? "มี" : "ไม่มี", alignment: "center" },
    ];
  };

  // --- กรองข้อมูลและเตรียม Body ---
  const validData = data_petty_cash
    ?.sort((a, b) => (a.status?.localeCompare(b.status) !== 0 ? a.status?.localeCompare(b.status) : a.time - b.time))
    .filter((e) => e.status !== "cancel") || [];

  const content = [];

  // ส่วนหัวรายงาน (Main Header)
  content.push(
    { text: `${project?.project_name || "ผู้ดูแลระบบ"}`, fontSize: 18, alignment: "center", bold: true },
    { text: `รายงานเงินสดย่อย`, fontSize: 16, alignment: "center", bold: true },
    { text: `สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`, fontSize: 14, alignment: "center", bold: true, margin: [0, 0, 0, 10] }
  );

  validData.forEach((item, idx) => {
    const labels = getDynamicLabels(item);
    // บังคับให้ตารางมีอย่างน้อย 1 ช่องเสมอเพื่อไม่ให้ pdfMake error (colSpan ห้ามเป็น 0)
    const typeColsCount = Math.max(1, labels.length);

    // คำนวณความกว้างคอลัมน์แบบไดนามิก
    const widths = [20, 45, '*', 30, 30]; 
    for (let i = 0; i < typeColsCount; i++) widths.push(35); // คอลัมน์ประเภทค่าใช้จ่าย
    widths.push(40, 40, 40, 30, 30); // คอลัมน์ส่วนท้าย (รวมทั้งหมด = 10 + typeColsCount)

    // สร้าง Header แถวที่ 1 (Merged) - แก้ไข colSpan และ dummy {} ให้จำนวนพอดี
    const headerRow1 = [
      { text: "ข้อมูลการใช้จ่ายเงินสดย่อย", colSpan: 3, alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      {}, 
      {}, // colSpan 3 ต้องมี {} 2 ตัว
      { text: "ใบสำคัญ", colSpan: 2, alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      {}, // colSpan 2 ต้องมี {} 1 ตัว
      { text: "ประเภทการจ่าย", colSpan: typeColsCount + 1, alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      ...Array(typeColsCount - 1).fill({}), // แก้บั๊ก: colSpan = typeColsCount ต้องมี {} จำนวน typeColsCount - 1
      {}, // แก้บั๊ก: รวบยอดรวมและคงเหลือ ต้องมี colSpan 2 และ {} 1 ตัว
      { text: "เงินสดย่อย", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "สถานะ", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "หมายเหตุ", colSpan: 2, alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      {} // แก้บั๊ก: colSpan 2 ของหมายเหตุ ต้องมี {} แค่ 1 ตัว (เดิมใส่มา 2 ตัว)
    ];

    // สร้างคอลัมน์ประเภทค่าใช้จ่าย (ถ้าไม่มี label เลยให้ใส่ขีดกลางแทนเพื่อรักษาโครงสร้าง)
    const labelHeaders = labels.length > 0 
      ? labels.map(l => ({ text: l, alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true }))
      : [{ text: "-", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true }];

    // สร้าง Header แถวที่ 2 (ชื่อคอลัมน์)
    const headerRow2 = [
      { text: "ลำดับ", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "วันที่", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "รายการค่าใช้จ่าย", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "เล่มที่", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "เลขที่", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      ...labelHeaders,
      { text: "ยอดรวม", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "คงเหลือ", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true }, // อันนี้จะตรงกับช่อง "สถานะ"
      { text: "ใบเสร็จ", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
      { text: "สำเนาบัตร", alignment: "center", fillColor: "#198754", color: "#ffffff", bold: true },
    ];

    // ประกอบร่าง Table Body
    const tableBody = [headerRow1, headerRow2];
    tableBody.push(createDataRow(item.limit_withdraw, "", labels, item, true));
    tableBody.push(createDataRow(item.previuse_balance, "", labels, item, true));
    tableBody.push(createDataRow(item.cash_withdraw, "", labels, item, true));
    
    item.list_cash_spend?.forEach((cash, cIdx) => {
      tableBody.push(createDataRow(cash, cIdx, labels, item));
    });

    const sumExpenses = total(item?.list_cash_spend?.map((d) => total(d.amount, "amount")));

    // เพิ่มลงใน content
    content.push(
      { text: `${item.project_name || ""} ${format_date(new Date(item.year, item.month - 1), "mmmm yyyy", "th")} (ครั้งที่ ${item.time})`, fontSize: 13, bold: true, margin: [0, 10, 0, 5] },
      {
        table: {
          headerRows: 2,
          widths: widths,
          body: tableBody
        },
        fontSize: 9
      },
      {
        margin: [0, 5, 0, 15],
        columns: [
          { text: "", width: "*" },
          {
            width: "auto",
            stack: [
              {
                columns: [
                  { text: "ค่าใช้จ่ายรวมทั้งสิ้น", alignment: "right", width: 150, bold: true },
                  { text: toFixed(sumExpenses), alignment: "right", width: 80, bold: true }
                ]
              },
              {
                columns: [
                  { text: "ยอดเงินสดย่อยคงเหลือทั้งสิ้น", alignment: "right", width: 150, bold: true },
                  { text: toFixed(Number(item.limit_withdraw.amount) - sumExpenses), alignment: "right", width: 80, bold: true }
                ]
              }
            ]
          }
        ]
      }
    );
  });

  const docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    content: content,
    defaultStyle: { font: "THSarabunNew", fontSize: 12, lineHeight: 1 },
    pageMargins: [20, 20, 20, 20],
  };

  print(docDefinition, `รายงานเงินสดย่อย.pdf`);
}
async function report_petty_cash_report_full(data_petty_cash,year,month) {
  const status = {
  pending: {
    name: "รอตรวจสอบ",
    style: "text-warning",
    role: "super_user,admin,accounting",
  },
  fix: {
    name: "แก้ไข",
    style: "text-danger",
    role: "super_user,admin,accounting",
  },
  fixed: {
    name: "แก้ไขแล้ว",
    style: "text-info",
    role: "super_user,admin,accounting",
  },
  approved: {
    name: "อนุมัติ",
    style: "text-success",
    role: "super_user,admin,accounting",
  },
};
  function cal(id, cash_id) {
      let amount = 0;
      data_petty_cash.forEach((item, index) => {
        if (index === id) {
          item.list_cash_spend?.forEach((cash, cash_index) => {
            if (cash_index <= cash_id) {
              amount += total(cash.amount, "amount");
            }
          });
        }
      });
      return Number(data_petty_cash[id]?.limit_withdraw?.amount) - amount;
    };
  function objectTable(petty_cash,item,cash_index, id) {
    return {
      stack: [
        { text: `${petty_cash.project_name || ""} ${format_date(new Date(petty_cash.year, petty_cash.month - 1), "mmmm yyyy", "th")} (ครั้งที่ ${petty_cash.time})`, fontSize: 20, bold: true, alignment: "left"},
        { text: ` `, fontSize: 4 },
        {
          table: {
            headerRows: 0,
            widths: [25, "auto", "*", 40, 40, 40, 40, 40, 40, 40, 40, 40, "auto", "auto", "auto"],
            body: [
              [
                { text: "ลำดับ", alignment: "center"},
                { text: "วันที่", alignment: "center"},
                { text: "รายการค่าใช้จ่าย", alignment: "center"},
                { text: "เล่มที่", alignment: "center"},
                { text: "เลขที่", alignment: "center"},
                { text: petty_cash.expenses_type_label_1 || "", alignment: "center"},
                { text: petty_cash.expenses_type_label_2 || "", alignment: "center"},
                { text: petty_cash.expenses_type_label_3 || "", alignment: "center"},
                { text: petty_cash.expenses_type_label_4 || "", alignment: "center"},
                { text: petty_cash.expenses_type_label_5 || "", alignment: "center"},
                { text: "ยอดรวม", alignment: "center"},
                { text: "คงเหลือ", alignment: "center"},
                { text: "สถานะ", alignment: "center"},
                { text: "ใบเสร็จ", alignment: "center"},
                { text: "สำเนาบัตร", alignment: "center"},
              ],
              [
                { text: cash_index === "" ? "" : cash_index + 1, alignment: "center"},
                { text: item.date ? format_date(item.date) : "", alignment: "center"},
                { text: item.name || "" , alignment: "left"},
                { text: item.volumn_no || "" , alignment: "left"},
                { text: item.no || "" , alignment: "left"},
                ...[
                  { text: toFixed(item?.amount[0]?.amount || 0) , alignment: "right"},
                  { text: toFixed(item?.amount[1]?.amount || 0) , alignment: "right"},
                  { text: toFixed(item?.amount[2]?.amount || 0) , alignment: "right"},
                  { text: toFixed(item?.amount[3]?.amount || 0) , alignment: "right"},
                  { text: toFixed(item?.amount[4]?.amount || 0) , alignment: "right"},
                ],
                { text: item.amount ? toFixed(total(item.amount, "amount")) : "" , alignment: "right"},
                { text: toFixed(typeof item.amount === "object" ? cal(id, cash_index) || 0 : item.amount) , alignment: "right"},
                { text: status[item.status]?.name || "" , alignment: "center"},
                { text: item.receipt ? "มี" : "ไม่มี" , alignment: "center"},
                { text: item.copy_id_card ? "มี" : "ไม่มี" , alignment: "center"},
              ]
            ]
          }
        },
        { text: ` `, fontSize: 4 },
        { columns: [
          item.image_slip[0] ? { image: item.image_slip[0], fit: [430, 430] } : { text: "" },
          { text: ` `, fontSize: 4, width: 50 },
          item.image_slip[1] ? { image: item.image_slip[1], fit: [430, 430] } : { text: "" },
        ]},
        { text: "", pageBreak: "after" },
      ]
    }
    
  }
   const body = JSON.stringify([
    { text: `${project["project_name"]}`, fontSize: 28, alignment: "center", bold: true  },
    { text: `รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย`, fontSize: 28, alignment: "center", bold: true  },
    { text: `สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`, fontSize: 28, alignment: "center", bold: true  },
    { text: "", pageBreak: "after" },
    ...data_petty_cash?.map((item, index) => item.list_cash_spend?.map((cash, cash_index) => objectTable(item, cash, cash_index, index))),
  ]);
  var docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape", 
    content: [
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 12, lineHeight: 1 },
    pageMargins: [20, 20, 20, 20],
  };

  print(docDefinition, `รายงานเงินสดย่อย รายละเอียด.pdf`);
}

// รายการค้างชำระ
async function report_outstanding_payments(data, end_date) {
  let array = data.map((item, index) => {
    item.other_income = item.other_income + item.fire_cost;
    item.other_income = item.other_income + item.cable_cost;
    return [
      { text: index + 1, alignment: "center" },
      { text: item.address_number ? item.address_number : "-", alignment: "center" },
      { text: item.full_name ? item.full_name : "-", alignment: "left" },
      { text: format_date(item.createdAt), alignment: "center" },
      { text: item.last_gauge_number, alignment: "center" },
      { text: item.current_gauge_number, alignment: "center" },
      { text: item.unit_used ? item.unit_used : "0", alignment: "center" },
      { text: item.water_bill ? toFixed(item.water_bill) : "0.00", alignment: "center" },
      { text: item.equipment_maintenance_fee ? toFixed(item.equipment_maintenance_fee) : "0.00", alignment: "center" },
      { text: item.common_expenses ? toFixed(item.common_expenses) : "0.00", alignment: "center" },
      { text: item.waste_cost ? toFixed(item.waste_cost) : "0.00", alignment: "center" },
      { text: item.other_income || item.meter_connect_cost ? toFixed(item.other_income + item.meter_connect_cost) : "0.00", alignment: "center" },
      { text: item.add_debt ? toFixed(item.add_debt) : "0.00", alignment: "center" },
      { text: item.reduce_debt ? toFixed(item.reduce_debt) : "0.00", alignment: "center" },
      { text: item.total_cost_late ? toFixed(item.total_cost_late) : "0.00", alignment: "center" },
      { text: toFixed(
                          item.water_bill +
item.equipment_maintenance_fee +
item.common_expenses +
item.waste_cost +
item.cable_cost +
item.other_income +
item.add_debt +
item.fire_cost +
item.meter_connect_cost +
item.total_cost_late - item.reduce_debt
                        ), alignment: "center" },
    ];
  });
  const docDefinition = {
    content: [
      { text: project["project_name"], alignment: "left", fontSize: 18, bold: true },
      { text: "รายงานแจ้งหนี้ค่าน้ำและค่าส่วนกลางค้างชำระ ณ วันที่ " + format_date(end_date || new Date(), "dd mmmm yyyy"), alignment: "left", fontSize: 14, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["2.54%", "5.5%", "15.68%","7.74%", "5.64%", "5.64%", "5.14%", "6.64%", "6.64%", "6.14%", "5.64%", "5.64%", "4.14%", "4.14%", "5.0%", "7.14%"],

          body: [
            [{ text: "#", alignment: "center" }, { text: "บ้านเลขที่", alignment: "center" }, { text: "ชื่อ-นามสกุล", alignment: "center" }, { text: "จดมาตร ประจำเดือน", alignment: "center" }, { text: "เลขมาตร เดือนก่อน", alignment: "center" }, { text: "เลขมาตร เดือนนี้", alignment: "center" }, { text: "หน่วยใช้", alignment: "center" }, { text: "ค่าน้ำ ประปา", alignment: "center" }, { text: "ค่าบริการ", alignment: "center" }, { text: "ค่าส่วนกลาง", alignment: "center" }, { text: "ค่าขยะ", alignment: "center" }, { text: "เงินทุนอื่น", alignment: "center" }, { text: "เพิ่ม/ลดหนี้", alignment: "center", colSpan: 2 }, "", { text: "ค่าปรับ ล่าช้า", alignment: "center" }, { text: "รวม (บาท)", alignment: "center" }],
            ...array,
            [{ text: "รวมทั้งสิ้น", colSpan: 6, alignment: "left" }, "", "", "", "", "", { text: total(data, "unit_used"), alignment: "center" }, { text: toFixed(total(data, "water_bill")), alignment: "center" }, { text: toFixed(total(data, "equipment_maintenance_fee")), alignment: "center" }, { text: toFixed(total(data, "common_expenses")), alignment: "center" }, { text: toFixed(total(data, "waste_cost")), alignment: "center" }, { text: toFixed(total(data, "other_income") + total(data, "meter_connect_cost")), alignment: "center" }, { text: toFixed(total(data, "add_debt") - total(data, "reduce_debt")), alignment: "center", colSpan: 2 }, "", { text: toFixed(total(data, "total_cost_late")), alignment: "center" }, { text: toFixed(total(data, "total_amount") + total(data, "total_cost_late") + total(data, "meter_connect_cost")), alignment: "center" }],
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 9, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };
  let textDocDefinition = await replaceText(docDefinition);
  open(textDocDefinition, "รายการค้างชำระ.pdf");
}

// รายการชำระเงิน
async function reports(title, data_list, font_size) {
  
  const body = JSON.stringify([
    { text: title, fontSize: 24, alignment: "left", bold: true },
    { text: ` `, fontSize: 4 },
    data_list,
    { text: ` `, fontSize: 4 },
  ]);
  var docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    content: [
      ...JSON.parse(body)
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: font_size || 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

async function report_categorized_report(data = [], data_expenses = [], year, month) {
  let array_month = [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ]
  const bodyRows = data.map((item, index) => {
    const typeName =
      data_expenses?.find(
        (e) => e.expense_type_id === item?.expenses_type_center
      )?.expense_type_name || "-";

    return [
      { text: format_date(item?.date) || "-", alignment: "center" },
      { text: item?.title || "-", alignment: "left" },
      { text: typeName, alignment: "left" },
      { text: toFixed(item?.amount || 0), alignment: "right" },
      { text: Array.isArray(item?.image) ? item.image.join(", ") : item?.image || "-", alignment: "center" },
    ];
  });

  const docDefinition = {
    content: [
      {
        text: "รายงานแยกประเภทค่าใช้จ่าย",
        fontSize: 16,
        bold: true,
        alignment: "center"
      },
      {
        text: project?.project_name,
        fontSize: 16,
        bold: true,
        alignment: "center"
      },
      {
        text: "ประจำเดือน" + array_month[month ? (month - 1) : new Date().getMonth()] + " " + ((year || new Date().getFullYear()) + 543),
        fontSize: 16,
        bold: true,
        alignment: "center"
      },
     {
  text: `ประจำปี ณ เดือน ${
    month
      ? `${array_month[month - 1]} ${(year || new Date().getFullYear()) + 543} - ${array_month[month - 1]} ${(year || new Date().getFullYear()) + 543}`
      : `${array_month[0]} ${(year || new Date().getFullYear()) + 543} - ${array_month[11]} ${(year || new Date().getFullYear()) + 543}`
  }`,
  fontSize: 16,
  bold: true,
  alignment: "center"
},
{text: " "},
      {
        table: {
          headerRows: 1,
          widths: [60, "*", 60, 60, 150],

          body: [
            [
              { text: "ณ สิ้นสุดวันที่", bold: true, alignment: "center" },
              { text: "รายการ", bold: true, alignment: "center" },
              { text: "แยกประเภท", bold: true, alignment: "center" },
              { text: "ยอดเงิน", bold: true, alignment: "center" },
              { text: "link รูปภาพ", bold: true, alignment: "center" },
            ],

            ...bodyRows,

            [
              { text: "รวมทั้งสิ้น", colSpan: 3, alignment: "right", bold: true }, "", "",
              {
                text: toFixed(total(data, "amount")),
                alignment: "right",
                bold: true,
              },
              "",
            ],
          ],
        },

        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? "#198754" : null),
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
        },
      },
    ],

    defaultStyle: {
      font: "THSarabunNew",
      fontSize: 16,
    },

    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  open(textDocDefinition, "summary.pdf");
}

// รายการ รหัสลูกค้าโครงการ
async function report_customer(data_list) {
  
  const body = JSON.stringify([
    { text: "ชื่อผู้ใช้และรหัสผ่านตั้งต้นของลูกค้าโครงการ", fontSize: 24, alignment: "left", bold: true },
    { text: ` `, fontSize: 4 },
     {
          table: {
            headerRows: 0,
            widths: [50, "*", "*"],
            body: [
              [
                { text: "เลขที่ห้อง", alignment: "center"},
                { text: "ชื่อผู้ใช้", alignment: "center"},
                { text: "รหัสผ่าน", alignment: "center"},
              ],
              ...(data_list || []).filter(e=>e.id_card).map((item, index) => (
              [
                { text: item.address_number || "", alignment: "center", margin: [0, 12]},
                { text: `${project?.project_code?.slice(-3) || ""}-${(item.building ?? "").toString().padStart(2, "0")}-${item.address_number || ""}-${(item.id_card || "").toString().slice(-6)}`, alignment: "center", margin: [0, 12]},
                { text: item.address_number || "", alignment: "center", margin: [0, 12]},
              ]))
            ]
          }
        },
      { text: ` `, fontSize: 20 },
      { text: `username: ${project?.project_code.slice(-3)}-(อาคารของลูกค้า 2 หลัก)-(บ้านเลขที่)-(เลขบัตรประชาชน 6 หลักสุดท้าย)` },
      { text: `password: (บ้านเลขที่)` },
      
      { text: ` `, fontSize: 4 },
      { text: "ตัวอย่าง", bold: true },

      { text: `username: ${project?.project_code.slice(-3)}-01-406/02-123456` },
      { text: `password: 406/02` }
  ]);
  var docDefinition = {
    pageSize: "A4",
    // pageOrientation: "landscape",
    content: [
      ...JSON.parse(body)
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}


export {
  report_cash_flow_report_table,
  report_cash_flow_report_full,
  report_petty_cash_report_table,
  report_petty_cash_report_full,
  report_outstanding_payments,
  reports,
  report_categorized_report,
  report_customer
};
